import { CORGI_PACK_SIZE } from "./treats";
import { isSpecialCorgiId } from "./cardCatalog";

const isSpecialPackDrop = (drop = {}) =>
    drop?.rarity === "alpha" ||
    drop?.rarity === "gem" ||
    drop?.rarity === "founder" ||
    isSpecialCorgiId(drop.id);

export const PACK_REVEAL_PAGE_SIZE = CORGI_PACK_SIZE;

export function chunkPackDrops(drops = [], pageSize = PACK_REVEAL_PAGE_SIZE) {
    const size = Math.max(1, Math.floor(Number(pageSize) || PACK_REVEAL_PAGE_SIZE));
    const list = Array.isArray(drops) ? drops : [];
    const pages = [];

    for (let index = 0; index < list.length; index += size) {
        pages.push(list.slice(index, index + size));
    }

    return pages;
}

/** Evenly space cards around a circle, starting at the top (-90°). */
export function getPackRevealAngles(count = 1) {
    const total = Math.max(1, Math.floor(Number(count) || 1));
    const step = 360 / total;

    return Array.from({ length: total }, (_, index) => -90 + step * index);
}

export function getPackRevealLayout(count = 1, radiusPx = 118) {
    const radius = Math.max(0, Number(radiusPx) || 0);
    return getPackRevealAngles(count).map((angle) => {
        const radians = (angle * Math.PI) / 180;
        return {
            angle,
            x: Math.round(Math.cos(radians) * radius),
            y: Math.round(Math.sin(radians) * radius),
        };
    });
}

/** Alpha, Gem, Founder, or foil — face-down special back + motion in pack reveal. */
export function isPackDropSpecial(drop = {}) {
    return (
        drop?.rarity === "alpha" ||
        drop?.rarity === "founder" ||
        drop?.rarity === "gem" ||
        Boolean(drop?.isFoil)
    );
}

export function getPackDropHintClasses(drop = {}) {
    const classes = [];

    if (!isPackDropSpecial(drop)) {
        return classes;
    }

    classes.push("packRevealCard--special");

    if (drop.rarity === "founder") {
        classes.push("packRevealCard--hintFounder");
    } else if (drop.rarity === "gem") {
        classes.push("packRevealCard--hintGem");
    } else if (drop.rarity === "alpha") {
        classes.push("packRevealCard--hintAlpha");
    }

    if (drop.isFoil) {
        classes.push("packRevealCard--hintFoil");
    }

    return classes;
}


export function getPackDropBadge(drop = {}) {
    if (drop.isNewFoil) {
        return "New foil";
    }
    if (drop.isNew) {
        return "New";
    }
    return "";
}

/** Collection-style label: names for special corgis, card numbers for base cards. */
export function formatBaseCardDisplayName(cardOrName = null) {
    if (cardOrName && typeof cardOrName === "object") {
        const rarity = String(cardOrName.rarity || "")
            .trim()
            .toLowerCase();
        if (rarity && rarity !== "base") {
            const specialName = String(cardOrName.name ?? "").trim();
            return specialName || String(cardOrName.id ?? "").trim();
        }
        const id = String(cardOrName.id ?? "").trim();
        if (/^\d+$/.test(id)) {
            return id;
        }
        const name = String(cardOrName.name ?? "").trim();
        return name.replace(/^coco\s*/i, "") || name;
    }

    const name = String(cardOrName ?? "").trim();
    return name.replace(/^coco\s*/i, "") || name;
}

/** Collection-style label: names for special corgis, card numbers for base cards. */
export function formatPackDropLabel(drop = {}) {
    if (isSpecialPackDrop(drop)) {
        const name = String(drop.name ?? "").trim();
        return name || String(drop.id ?? "").trim();
    }

    return formatBaseCardDisplayName(drop);
}
